import Component from './Component'

export default class SearchGroup extends Component {

	static _type = 'SearchGroup'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	_field_listeners = {}

	tether () {
		super.tether()

		// Own DOM elements
		this.input_el = this.base.querySelector(`_${this.id}-dummy`)
		this.feedback_el = this.base.querySelector(`_${this.id}-invalid-feedback`)

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil
		//this.form.registerInput(this.params.name, this)

		// Grab a list of all fields we need to watch
		for (let field of this.params.fields) {
			if ('name' in field && !(field.name in this._field_listeners)) {
				// Create listener and register
				this._field_listeners[field.name] = SearchGroup._updateListener.bind({ that: this, name: field.name })
				this.form.data.record.on(field.name + '-updated', this._field_listeners[field.name])	// node event
			}
		}
	}

	static _updateListener (value, errors) {

		// Render validation
		this.that.renderValidation()

		// Determine if we have any truthy values
		let filled = false
		for (let field of this.that.params.fields) {
			if ('name' in field && this.that.params.op_name != field.name) {
				if (Array.isArray(this.that.form.data[field.name])) {
					// This is an array value
					if (this.that.form.data[field.name].length > 0) {
						filled = true
						break
					}
				} else {
					// Primitive value
					if (this.that.form.data[field.name]) {
						filled = true
						break
					}
				}
			}
		}
		if (filled) {
			if (this.that.form.data[this.that.params.op_name] == 0) this.that.form.data[this.that.params.op_name] = 1
		} else {
			if (this.that.form.data[this.that.params.op_name] > 0) this.that.form.data[this.that.params.op_name] = 0
		}

		// Update hook
		if ('update' in this.that.params && typeof this.that.params.update == 'function') {
			this.that.params.update(null, this.name, this.that.form.data, this.that.params)
		}
	}

	renderValidation () {

		// Get all the relevant field errors
		let errors = []
		for (let data_field of Object.keys(this._field_listeners)) {
			let field_err = this.form.data.record.getErrors(data_field)
			if (field_err !== null) {
				errors.push(...field_err)
			}
		}

		if (errors.length == 0) {
			// Validation successful
			$(this.input_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.input_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		for (let data_field of Object.keys(this._field_listeners)) {
			this.form.data.record.off(data_field + '-updated', this._field_listeners[data_field])
			this._field_listeners[data_field] = null
		}

		delete this.input_el
		delete this.feedback_el
		delete this.form

		super.destroy()
	}
}
